<div class="performance-card">
    <div class="performance-header">
        <h3 class="chart-title">{{ 'request_v2.analytics.perf_title' | translate }}</h3>
        <p class="chart-subtitle">{{ 'request_v2.analytics.perf_subtitle' | translate }}</p>
    </div>

    <div *ngIf="data.length === 0" class="no-data">
        {{ 'request_v2.analytics.no_data' | translate }}
    </div>

    <table *ngIf="data.length > 0" class="performance-table">
        <thead>
            <tr>
                <th>{{ 'request_v2.analytics.perf_col_service' | translate }}</th>
                <th>{{ 'request_v2.analytics.perf_col_category' | translate }}</th>
                <th>{{ 'request_v2.analytics.perf_col_sla' | translate }}</th>
                <th>{{ 'request_v2.analytics.perf_col_performance' | translate }}</th>
                <th>{{ 'request_v2.analytics.perf_col_status' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of data">
                <td class="service-name">{{ item.subCategoryName }}</td>
                <td class="category-name">{{ item.categoryName }}</td>
                <td class="sla-days">{{ item.slaInDays }} {{ 'request_v2.analytics.perf_days' | translate }}</td>
                <td class="performance-cell">
                    <div class="bar-container">
                        <div class="bar" [style.width.%]="item.complianceRate" [style.backgroundColor]="getBarColor(item.status)"></div>
                    </div>
                    <span class="rate-value">{{ item.complianceRate }} %</span>
                    <span class="rate-delta positive" *ngIf="getDelta(item) !== null && getDelta(item) > 0">+{{ getDelta(item) }} pts</span>
                    <span class="rate-delta negative" *ngIf="getDelta(item) !== null && getDelta(item) < 0">{{ getDelta(item) }} pts</span>
                    <span class="rate-delta muted" *ngIf="getDelta(item) !== null && getDelta(item) === 0">— 0 pts</span>
                    <span class="rate-delta new" *ngIf="isNewInPeriod(item)">N/A</span>
                </td>
                <td class="status-cell">
                    <span class="status-badge" [attr.data-status]="item.status">
                        {{ getStatusLabel(item.status) | translate }}
                    </span>
                </td>
            </tr>
        </tbody>
    </table>
</div>
